const ProductType = {
    CEMENT: "cement",
    STEEL: "steel",
    HARDWARE: "hardware"
}

export default ProductType;